// extracted by mini-css-extract-plugin
export default {"PasswordResetEmailForm__submit":"yx_a bhs_ql bhs_tq"};